import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

interface TriggerManageSavedSearchDailyStockToggleProps {
	id: number;
	sendEmailAlert: boolean;
}

const {
	MARKETPLACE: { MANAGE_SAVED_SEARCH },
} = ANALYTICS_CATEGORIES;

export const triggerManageSavedSearchDailyStockToggleEvent = ({
	id,
	sendEmailAlert,
}: TriggerManageSavedSearchDailyStockToggleProps): void => {
	const eventPayload = getSnowplowEventPayload({
		category: MANAGE_SAVED_SEARCH,
		customData: { label: `${id}` },
		name: `dlr_manage_saved_search_daily_stock_${sendEmailAlert ? 'on' : 'off'}`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
